module.exports = __webpack_public_path__ + "static/media/no-image-available-300.6ce5619d.png";